import receiptBottom from '@/assets/landing/receipt-bottom.svg'
import { SEALED_VINYL_DELIVERY_FEE_KRW } from '@/pages/SealedVinylPage/lib/constants'
import { formatPriceKrw } from '@/pages/SealedVinylPage/lib/utils'

import {
  FeeLabel,
  FeeRow,
  FeeValue,
  ItemRow,
  NoticeItem,
  NoticeList,
  PriceContainer,
  PriceTitle,
  ReceiptBottom,
  ReceiptBox,
  ReceiptDivider,
  ReceiptTop,
  TotalAmount,
  TotalBox,
  TotalBoxWrap,
  TotalLabel,
} from './styles'

const NOTICES = [
  { text: '도착 소요 시간은 결제 후 3영업일 입니다.', warn: false },
  { text: '주문수량 상관없이 동일한 금액입니다.', warn: false },
  { text: '주문취소/변경은 익일 오전 11시까지만 가능합니다.', warn: true },
]

export function PriceSection() {
  const deliveryFee = `${formatPriceKrw(SEALED_VINYL_DELIVERY_FEE_KRW)}원`

  return (
    <PriceContainer>
      <PriceTitle>
        <span>배송비만 결제하면</span>
        <span>0원에 드립니다</span>
      </PriceTitle>

      <ReceiptBox>
        <ReceiptTop />
        <ItemRow>
          <span>밀봉비닐 1~3박스</span>
          <span>0원</span>
        </ItemRow>
        <FeeRow>
          <FeeLabel>배송비</FeeLabel>
          <FeeValue>{deliveryFee}</FeeValue>
        </FeeRow>
        <ReceiptDivider />
        <TotalBoxWrap>
          <TotalBox>
            <TotalLabel>총 결제금액</TotalLabel>
            <TotalAmount>{deliveryFee}</TotalAmount>
          </TotalBox>
        </TotalBoxWrap>
        <ReceiptBottom
          src={receiptBottom}
          alt=''
        />
      </ReceiptBox>

      <NoticeList>
        {NOTICES.map((notice) => (
          <NoticeItem
            key={notice.text}
            warn={notice.warn}
          >
            · {notice.text}
          </NoticeItem>
        ))}
      </NoticeList>
    </PriceContainer>
  )
}
